// Фигура с сегментами мышц и жира, стрелки изменений к предыдущему полному замеру
// и предупреждение об асимметрии рядом.

import { Card } from '@/components/ui'

import type { InBodySummaryOut } from '../api'
import { BodyFigure } from '../BodyFigure'

export function FigureCard({ summary }: { summary: InBodySummaryOut }) {
  const segments = summary.latest?.segments
  if (!segments) return null
  const previous = summary.previous?.segments ?? null
  const sex = summary.latest?.sex === 'F' ? 'female' : 'male'
  return (
    <Card
      className="@container"
      title="Сегменты тела"
      subtitle="Стрелка — изменение к предыдущему полному замеру"
    >
      <BodyFigure segments={segments} previous={previous} sex={sex} />
      {summary.asymmetry.length > 0 ? (
        <ul className="mt-3 grid gap-1.5" aria-label="Асимметрия">
          {summary.asymmetry.map((a) => (
            <li
              key={`${a.kind}-${a.pair}`}
              role="status"
              className="rounded-lg bg-warning-soft px-3 py-2 text-sm text-warning"
            >
              {a.message_ru}
            </li>
          ))}
        </ul>
      ) : null}
    </Card>
  )
}
